/**
 * Protege a Dash Gerencial compartilhada com a instituição dona.
 * Redireciona para /login sem sessão, para /home se não houver acesso vigente
 * e para a dash admin se a sessão for administrativa.
 */

import { Navigate } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'
import styles from './ProtectedRoute.module.css'

interface SharedManagerialDashboardRouteProps {
  children: React.ReactNode
}

export function SharedManagerialDashboardRoute({ children }: SharedManagerialDashboardRouteProps) {
  const { token, guard, isLoading, isCollaborator, managerialDashboardAccess } = useAuth()

  if (isLoading) {
    return (
      <div className={styles.loading}>
        <div className={styles.spinner} />
        <p>Carregando...</p>
      </div>
    )
  }

  if (!token) {
    return <Navigate to="/login" replace />
  }

  if (guard === 'admin') {
    return <Navigate to="/dash-gerencial" replace />
  }

  if (guard !== 'institution' || isCollaborator || managerialDashboardAccess === null) {
    return <Navigate to="/home" replace />
  }

  return <>{children}</>
}
